import PropTypes from "prop-types";
import ProductCard from "../../components/ProductCard/ProductCard";
import { useEffect } from "react";
import RetroLoader from "../../components/RetroLoader/RetroLoader";

const sectionClass =
  "relative mx-auto mt-10 max-w-7xl overflow-hidden rounded-[2rem] border border-[#DDE7E5] bg-white/90 p-6 pb-10 shadow-xl backdrop-blur-xl dark:border-darkborder dark:bg-[#111114]/95 sm:p-8 lg:p-10";

const badgeClass =
  "mb-4 inline-flex rounded-full border border-primary/40 bg-primary/10 px-4 py-1.5 font-customFont1 text-xs font-extrabold uppercase tracking-[0.14em] !text-[#111827] shadow-sm dark:!text-white";

const titleClass =
  "font-customFont2 text-4xl font-bold uppercase leading-none !text-[#111827] dark:!text-white sm:text-5xl lg:text-6xl";

const introTextClass =
  "mt-5 max-w-4xl font-customFont1 text-lg leading-relaxed !text-[#374151] dark:!text-[#D1D5DB] sm:text-xl";

const productGridClass =
  "mt-9 grid grid-cols-1 gap-4 xsm:grid-cols-2 sm:grid-cols-3 md:grid-cols-3 mdd:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6";

const SoundRental = ({
  devices,
  addToCart,
  removeFromCart,
  incrementQuantity,
  decrementQuantity,
  cartItems,
  selectedQuantities,
}) => {
  useEffect(() => {
    if (devices && devices.length > 0 && window.gtag) {
      window.gtag("event", "vuokrakategoria_naytetty", {
        kategoria: "aanentoisto",
        tuotteita: devices.length,
        sivu: "vuokrattavat",
      });
    }
  }, [devices]);

  // Jos laitelista on tyhjä, näytetään viesti
  if (!devices || devices.length === 0) {
    return (
      <section className={sectionClass} aria-labelledby="aanentoisto-title">
        <div
          aria-hidden="true"
          className="
            pointer-events-none absolute -right-20 -top-20 h-56 w-56
            rounded-full bg-primary/10 blur-3xl
            dark:bg-primary/10
          "
        />

        <div className="relative text-center">
          <span className={badgeClass}>Vuokrattavat</span>

          <h2 id="aanentoisto-title" className={titleClass}>
            Äänentoisto
          </h2>

          <p className={`${introTextClass} mx-auto`}>
            Vuokraa laadukkaat äänentoistolaitteet juhliin, keikoille ja
            tapahtumiin.
          </p>

          <div className="mt-8">
            <RetroLoader text="Ladataan äänentoistolaitteita…" />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={sectionClass} aria-labelledby="aanentoisto-title">
      <div
        aria-hidden="true"
        className="
          pointer-events-none absolute -right-20 -top-20 h-56 w-56
          rounded-full bg-primary/10 blur-3xl
          dark:bg-primary/10
        "
      />

      <div className="relative">
        <span className={badgeClass}>Vuokrattavat</span>

        <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <h2 id="aanentoisto-title" className={titleClass}>
              Äänentoisto
            </h2>

            <p className={introTextClass}>
              Vuokraa laadukkaat äänentoistolaitteet juhliin, keikoille ja
              tapahtumiin. Valikoimasta löydät aktiivikaiuttimet, subwooferit,
              lavamonitorit, mikrofonit ja muut PA-järjestelmän keskeiset
              laitteet niin pieniin kotibileisiin kuin yritystapahtumiin ja
              live-esiintymisiin.
            </p>
          </div>

          <div
            className="
              w-full rounded-3xl border border-primary/30 bg-primary/10 p-4
              dark:border-primary/30 dark:bg-primary/5
              lg:max-w-xs
            "
          >
            <p
              className="
                font-customFont1 text-sm font-bold leading-relaxed
                !text-[#111827]
                dark:!text-white
              "
            >
              Valitse vuokra-aika tuotteen sivulla ja lisää sopiva kokonaisuus
              vuokrauskoriin.
            </p>
          </div>
        </div>

        <div className={productGridClass}>
          {devices.map((item) => (
            <ProductCard
              key={item.id}
              item={item}
              isBooked={item.isBooked}
              isDisabled={item.stock === 0}
              addToCart={addToCart}
              removeFromCart={removeFromCart}
              incrementQuantity={incrementQuantity}
              decrementQuantity={decrementQuantity}
              cartItems={cartItems}
              selectedQuantities={selectedQuantities}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

SoundRental.propTypes = {
  devices: PropTypes.array.isRequired,
  addToCart: PropTypes.func.isRequired,
  removeFromCart: PropTypes.func.isRequired,
  incrementQuantity: PropTypes.func.isRequired,
  decrementQuantity: PropTypes.func.isRequired,
  cartItems: PropTypes.array.isRequired,
  selectedQuantities: PropTypes.object.isRequired,
};

export default SoundRental;